'use es6';

import { EERIE } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import PropTypes from 'prop-types';
import { AVAILABLE, AWAY, BUSY, INACTIVE, OFFLINE } from '../constants/agent-state';
import AgentAvatar from './AgentAvatar';
import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getAgentStatusMessage = ({
  agentState,
  agent
}, isUngatedForWorkingHours) => {
  if (isUngatedForWorkingHours && agent.isOutOfOffice && agent.outOfOfficeEndsAt) {
    const returnTime = I18n.moment(agent.outOfOfficeEndsAt);
    const format = returnTime.isSame(new Date(), 'day') ? 'LT' : 'short-date'; // LT -> 9:30 PM, short-date -> Apr 23
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "routing-ui.reassignment.statusTypes.OUT_OF_OFFICE",
      options: {
        dateOrTime: /*#__PURE__*/_jsx(FormattedDateTime, {
          type: "userTz",
          value: returnTime.valueOf(),
          format: format
        })
      }
    });
  }
  if (isUngatedForWorkingHours && agentState === AWAY && !agent.isInWorkingHours) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.reassignment.statusTypes.AWAY_OUTSIDE_WH"
    });
  }
  switch (agentState) {
    case AVAILABLE:
    case BUSY:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.reassignment.statusTypes.AVAILABLE"
      });
    case AWAY:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.reassignment.statusTypes.AWAY"
      });
    case INACTIVE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.reassignment.statusTypes.INACTIVE"
      });
    case OFFLINE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.reassignment.statusTypes.OFFLINE"
      });
    default:
      return null;
  }
};
const ResponderOption = ({
  agentId,
  agentState,
  AsyncUIAvatar,
  avatar,
  currentAssigneeId,
  email,
  firstName,
  isAssignable,
  lastName,
  responder,
  isUngatedForWorkingHours // TODO: remove when ungated CT-18300
}) => /*#__PURE__*/_jsx(UITooltip, {
  disabled: isAssignable,
  title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "routing-ui.reassignment.disabledUsersTooltip"
  }),
  placement: "bottom",
  children: /*#__PURE__*/_jsx(UIMediaObject, {
    align: "center",
    className: "p-x-5 p-y-2",
    "data-test-id": "reassignment-responder-option",
    style: {
      lineHeight: 'normal'
    },
    itemLeft: /*#__PURE__*/_jsx(AgentAvatar, {
      AsyncUIAvatar: AsyncUIAvatar,
      avatar: avatar,
      away: agentState === AWAY,
      disabled: !isAssignable,
      showStatus: Boolean(responder),
      size: "xs",
      style: {
        border: 'none'
      }
    }),
    children: /*#__PURE__*/_jsxs("span", {
      className: "nowrap display-flex align-center",
      "data-test-id": "reassignment-dropdown-responder",
      children: [/*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(UITruncateString, {
          tooltip: false,
          children: /*#__PURE__*/_jsx(FormattedName, {
            givenName: firstName,
            familyName: lastName,
            email: email
          })
        }), isAssignable && /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: getAgentStatusMessage(responder, isUngatedForWorkingHours)
        })]
      }), agentId === currentAssigneeId && /*#__PURE__*/_jsx(UIIcon, {
        name: "success",
        style: {
          color: EERIE,
          marginLeft: '1.2em'
        },
        size: 15
      })]
    })
  })
});
ResponderOption.displayName = 'ResponderOption';
ResponderOption.defaultProps = {
  agentState: OFFLINE
};
ResponderOption.propTypes = {
  AsyncUIAvatar: PropTypes.func.isRequired,
  agentId: PropTypes.number,
  agentState: PropTypes.string,
  avatar: PropTypes.string,
  currentAssigneeId: PropTypes.number,
  email: PropTypes.string,
  firstName: PropTypes.string,
  isAssignable: PropTypes.bool,
  isUngatedForWorkingHours: PropTypes.bool,
  // TODO: remove when ungated CT-18300
  lastName: PropTypes.string,
  responder: PropTypes.object
};
export default ResponderOption;